export default {
      id: "arcs_recherche-usage",
      viewBox: "0 0 2000 820",
      url: "../dist/images/" + "sprite.svg#arcs_recherche-usage",
      toString: function () {
        return this.url;
      }
    }